module.exports = __webpack_public_path__ + "cd511f56eca9a7652bcf6734731a5768.png";